import React from "react";
import Header from "../../../components/Header/Header";
import LeftSideBar from "../../../components/LeftSideBar/LeftSideBar";
import { Box, Grid, IconButton } from "@mui/material";
import "./addGroup.scss";
import TextField from "@mui/material/TextField";
import { Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link } from "react-router-dom";
import Buttons from "../../../components/Controls/Buttons/Button";
import * as acts from "../../../redux/administrator/actions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import { messages } from "../../../constants/commonMessages";
import { adminRoutes } from "../../../routes/routeConstants";
const Index = (props) => {
  const [group, setGroup] = React.useState(props?.location?.state?.name);
  const Dispatch = useDispatch();
  const navigate = useNavigate();

  const data = useSelector((state) => state?.admin?.group);
  let isOpen = false;
  let text = "";
  let severity = "";
  if (data.message === "group added") {
    isOpen = true;
    text = "Group Added";
    severity = "success";
  } else if (data.message === "group edited") {
    isOpen = true;
    text = messages.GROUP_EDIT;
    severity = messages.SUCCESS;
  } else if (data.message === "error") {
    isOpen = true;
    text = messages.FAIL;
    severity = messages.ERROR;
  }

  const groupId = props?.location?.state?.id;

  const HandleSubmit = () => {
    if (groupId) {
      Dispatch(acts.editGroup(group, groupId));
      setTimeout(() => {
        navigate(`/${adminRoutes.listPage}`)
      }, 2000);
    } else {
      Dispatch(acts.addNewGroup(group));
      setTimeout(() => {
        navigate(`/${adminRoutes.listPage}`)
      }, 5000);
    }
  };

  return (
    <>
      <Header page="addgroup" />
      {isOpen ? (
        <CustomizedSnackbars
          className="popup"
          handleClose={() => {
            isOpen = false;
          }}
          severity={severity}
          state={isOpen}
          text={text}
        />
      ) : (
        <></>
      )}
      <Box>
        <Grid className="sidebar-main" container>
          <Grid item className="sidebar-container">
            <LeftSideBar page="sidebar" />
          </Grid>
          <Grid item className="visualization-conatiner">
            <form
              onSubmit={(event) => {
                 event.preventDefault(); HandleSubmit();
              }}
            >
              <Box className="side-bar-wrap">
                {/* <Link to="/list-page"> */}
                <Link to={`/${adminRoutes.listPage}`}>
                  <IconButton className="backButton">
                    <ArrowBackIcon />
                  </IconButton>
                </Link>
                <p className="addGroup-massage">
                  {" "}
                  {groupId ? messages.EDIT_GROUP : messages.ADD_NEW_GROUP}
                </p>
              </Box>
              <Box className="addGrouip-wrap">
                <div className="center-div">
                  <Typography variant="subtitle2">Group Name</Typography>
                  <TextField
                    placeholder="Group Name"
                    required
                    value={group}
                    onChange={(event) => setGroup(event.target.value)}
                    onInvalid={(e) => (e.target.style.border = "1px solid red")}
                  />
                </div>
              </Box>
              <Box className="bottom-div">
                <Buttons
                  variant="contained"
                  size="large"
                  text="save"
                  type="submit"
                />
              </Box>
            </form>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default Index;
